import Config from '@/utils/config'

const FALLBACK_ORIGIN = 'https://instore.mysoundz.ch'

/**
 * Absolute URLs for the head.
 *
 * The locale segment is optional in the router, so `/kontakt` and `/de/kontakt`
 * serve the same page. The unprefixed form is what gets linked and shared, so
 * that is the one everything consolidates on — while there is a single
 * language, a `/de` canonical would point at the variant nobody links to.
 */
export const canonicalOrigin = (): string => {
  if (Config.baseUrl) return Config.baseUrl.replace(/\/+$/, '')
  if (typeof window !== 'undefined') return window.location.origin
  return FALLBACK_ORIGIN
}

/** og:image and friends are only honoured as absolute URLs. */
export const absoluteUrl = (path: string): string =>
  path.startsWith('http') ? path : new URL(path, canonicalOrigin()).toString()
